import { render, staticRenderFns } from "./material-table.vue?vue&type=template&id=6876384d&scoped=true"
import script from "./material-table.vue?vue&type=script&lang=js"
export * from "./material-table.vue?vue&type=script&lang=js"
import style0 from "./material-table.vue?vue&type=style&index=0&id=6876384d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876384d",
  null
  
)

export default component.exports